import React from 'react';
import { hashHistory, Link } from 'react-router'
import { inject, observer } from "mobx-react/index";
import { autorun } from 'mobx';
import LeafletMap from "../../LeafletMap";
import { getCenter } from "../../Map/getCenterLatLng";
import Form from "../../Form";
import DataTable from "../../DataTable";
import TicketInfoTable from "./TicketInfoTable";
import Spinner from "../../Spinner";

@inject('ticketStatusStore', 'ticketActionStore', 'ticketReasonStore', 'ticketStore', 'userStore', 'stationStore')
@observer
export default class TicketMapLeaflet extends React.Component {

  state = {
    markers: [],
    markerIcons: [],
    mapCenter: null
  };

  dispose;


  // componentWillMount() {
  //   const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all} = this.props;
  //   this.dispose = autorun(() => {
  //     this.resetMarkers(ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all);
  //   })
  // }
  //
  //
  // componentWillReceiveProps(nextProps) {
  //   const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all} = nextProps;
  //   if(this.props.view_archived !== view_archived || this.props.assigned_to_all !== assigned_to_all)
  //     this.resetMarkers(ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all);
  // }

  resetMarkers = (ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, view_archived, assigned_to_all, userStore) => {
    const markers = ticketStatusStore.items.length > 0 && ticketReasonStore.items.length > 0 && ticketActionStore.items.length > 0
      ? ticketStore.getMarkers()
      : [];
    const markerIcons = this.filterMarkerByShow(markers).map(marker => (
      Object.assign({}, {
        id: 'ticket_marker-' + marker.tickets[0].id,
        station_id: marker.station_id,
        position: [marker.latitude, marker.longitude],
        icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
        iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
        // popupBox: this.getPopupBox(marker)
      })
    ));
    let mapCenter = getCenter(markers);
    this.setState({ markers, mapCenter, markerIcons });
  }

  // componentWillUnmount() {
  //   this.dispose();
  // }
  // getInfoTableData = (markers) => {
  //   const {ticketStatusStore, ticketActionStore, ticketReasonStore} = this.props;
  //   let tickets =  [];
  //   markers.map(item => {
  //     tickets.push(...item.tickets)
  //   });
  //   if(+ticketStore.viewBy === 1){
  //     return ticketStatusStore.items.map(item => {
  //       return {
  //         id: item.id,
  //         caption: item.caption,
  //         color: <i className='fa fa-circle' style={{color: item.color}}/>,
  //         number: tickets ? tickets.filter(ticket => ticket && +ticket.status_id === +item.id).length : '-'
  //       }
  //     });
  //   } else if (+ticketStore.viewBy === 2) {
  //     return ticketReasonStore.items.map(item => {
  //       return {
  //         id: item.id,
  //         caption: item.caption,
  //         color: <i className='fa fa-circle' style={{color: item.color}}/>,
  //         number: tickets ? tickets.filter(ticket => ticket && +ticket.reason_id === +item.id).length : '-'
  //       }
  //     });
  //   } else if (+ticketStore.viewBy === 3) {
  //     return ticketActionStore.items.map(item => {
  //       return {
  //         id: item.id,
  //         caption: item.caption,
  //         color: <i className='fa fa-circle' style={{color: item.color}}/>,
  //         number: tickets ? tickets.filter(ticket => ticket && +ticket.action_id === +item.id).length : '-'
  //       }
  //     });
  //   }
  // };
  // renderSelectInputs = () => {
  //   const {ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore} = this.props;
  //   let showOptions = null;
  //   switch (+ticketStore.viewBy){
  //     case 1: showOptions = ticketStatusStore.items; break;
  //     case 2: showOptions = ticketReasonStore.items; break;
  //     case 3: showOptions = ticketActionStore.items; break;
  //     default: showOptions = null; break;
  //   }
  //   return (
  //     <div>
  //       <div className="formInput">
  //         <label>View By</label>
  //         <select value={ticketStore.viewBy || ''} onChange={ticketStore.onChangeViewBy}>
  //           {ticketStore.viewByOptions.map(option => (
  //             <option
  //               key={option.id}
  //               value={option.id}
  //             >
  //               {option.name}
  //             </option>
  //           ))}
  //         </select>
  //       </div>
  //       <div className="formInput">
  //         <label>Show</label>
  //         <select value={ticketStore.show || ''} onChange={ticketStore.onChangeShow}>
  //           <option value={''}>All</option>
  //           {showOptions && showOptions.map(option => (
  //             <option
  //               key={option.id}
  //               value={option.id}
  //             >
  //               {option.caption}
  //             </option>
  //           ))}
  //         </select>
  //       </div>
  //     </div>
  //   )
  // };
  // filterMarkerByShow = (markers) => {
  //   const {ticketStore} = this.props;
  //   if(!!ticketStore.viewBy && !!ticketStore.show){
  //     return markers.filter(marker => {
  //       switch(+ticketStore.viewBy){
  //         case 1: return !!marker.tickets.find(item => item.status_id === +ticketStore.show);
  //         case 2: return !!marker.tickets.find(item => item.reason_id === +ticketStore.show);
  //         case 3: return !!marker.tickets.find(item => item.action_id === +ticketStore.show);
  //         default: return false;
  //       }
  //     });
  //   } else {
  //     return markers
  //   }
  // };

  getFilteredMarkerIcons = markers => markers.reduce((acc, marker) => {
    if (!marker.latitude || !marker.longitude) return acc;
    const { ticketStore } = this.props;

    if (!!ticketStore.viewBy && !!ticketStore.show) {
      switch (+ticketStore.viewBy) {
        case 1: if (!marker.tickets.find(item => item.status_id === +ticketStore.show)) return acc; else break;
        case 2: if (!marker.tickets.find(item => item.reason_id === +ticketStore.show)) return acc; else break;
        case 3: if (!marker.tickets.find(item => item.action_id === +ticketStore.show)) return acc; else break;
        case 4: if (!marker.tickets.find(item => +item.assigned_to === +ticketStore.show)) return acc; else break;
        case 5: if (!marker.tickets.find(item => +item.user_id === +ticketStore.show)) return acc; else break;
        default: break;
      }
    }

    acc.push({
      id: 'ticket_marker-' + marker.tickets[0].id,
      station_id: marker.station_id,
      position: [marker.latitude, marker.longitude],
      latitude: marker.latitude, longitude: marker.longitude,
      icon: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px;">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `,
      iconHighlighted: `
        <svg id="${'ticket_marker-' + marker.station_id}" viewBox="0 0 10 10" x="20" width="20" style="margin-left: -3px; margin-top: -5px; border-radius: 100px; box-shadow: #367fa9 0 0 15px 3px">
          <circle cx="5" cy="5" r="4" stroke="white" stroke-width="0.5px" fill="${marker.color}" />
        </svg>
      `
    });
    return acc;
  }, []);

  getPopupBox = marker => {
    const { ticketStore } = this.props;

    if (!marker)
      return null
    else
      return (
        <div>
          <strong style={{ fontSize: '15px', fontWeight: 'bold' }}>{marker.station_name}</strong><br />
          <span className="fa fa-close" style={{ position: 'absolute', right: 2, top: 2 }} onClick={() => this.props.ticketStore.selectedMarker = null} />
          {!!marker.duration ? <small>{marker.duration}</small> : ''}
          <br />
          <div style={{ maxHeight: '220px', overflowY: 'scroll' }}>
            {marker.tickets
              .filter(ticket => {
                if (!ticketStore.show) return true;
                switch (+ticketStore.viewBy) {
                  case 1: return +ticket.status_id === +ticketStore.show;
                  case 2: return +ticket.reason_id === +ticketStore.show;
                  case 3: return +ticket.action_id === +ticketStore.show;
                  case 4: return +ticket.assigned_to === +ticketStore.show;
                  case 5: return +ticket.user_id === +ticketStore.show;
                  default: return false;
                }
              })
              .map(ticket => (
                <div key={`station-${marker.station_id}-ticket-${ticket.id}`}>
                  <Link to={`/monitoring/ticket/tabular/${ticket.id}/view`}>Ticket {ticket.id}</Link>
                  <table style={{ padding: '10px' }}>
                    <tbody>
                      <tr><th>Summary</th><td>{ticket.summary}</td></tr>
                      <tr><th>Description</th><td>{ticket.description}</td></tr>
                      <tr><th>Status</th><td>{ticket.status && ticket.status.caption}</td></tr>
                      <tr><th>Reason</th><td>{ticket.reason && ticket.reason.caption}</td></tr>
                      <tr><th>Action</th><td>{ticket.action && ticket.action.caption}</td></tr>
                      <tr><th>Assigned to</th><td>{ticket.user && ticket.user.name}</td></tr>
                    </tbody>
                  </table><br />
                </div>
              ))}
          </div>
        </div>
      )
  };

  onMarkerClick = marker => {
    let ticketId = marker.id.split('-')[1];
    hashHistory.push(`/monitoring/ticket/tabular/${ticketId}/view`)
  };

  render() {
    const { ticketStore, ticketStatusStore, ticketActionStore, ticketReasonStore, stationStore, userStore, view_archived, assigned_to_all } = this.props;
    if (ticketStore.isLoading || stationStore.isLoading || userStore.isLoading || ticketStatusStore.isLoading || ticketActionStore.isLoading || ticketReasonStore.isLoading) return <Spinner />
    // const {mapCenter, markers, markerIcons} = this.state;
    const markers = ticketStatusStore.items.length > 0 && ticketReasonStore.items.length > 0 && ticketActionStore.items.length > 0
      ? ticketStore.getMarkers()
      : [];
    const markerIcons = this.getFilteredMarkerIcons(markers);
    let mapCenter = getCenter(markerIcons);
    return (
      <div className='ticket-list-map'>
        <div className='flex-grow ticket-map'>
          <LeafletMap id='ticket_map' center={mapCenter} markers={markerIcons} selectedMarker={ticketStore.selectedMarker} width='100%' onMarkerClick={this.onMarkerClick} isLoading={ticketStore.isLoading} onMarkerOver={ticketStore.onMarkerOver}>
            {ticketStore.selectedMarker ? <div
              className='map-info-box'>{this.getPopupBox(markers.find(item => +item.station_id === +ticketStore.selectedMarker))}</div> : null}
          </LeafletMap>
        </div>
        <div>
          <TicketInfoTable />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/Ticket/TicketMapLeaflet.js